
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */

import DocsBeta from 'src/components/docs/DocsBeta/index.tsx';

export const metadata = {
  toc: true,
  layout: 'guide',
  minTocLevel: 4,
  source: 'error',
  description: 'Guide to understanding and troubleshooting reCAPTCHA errors, which indicate that the user must solve a reCAPTCHA challenge before proceeding.'
};
const makeShortcode = name => function MDXDefaultShortcode(props) {
      console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
      return <div {...props}/>
    };
const Header = makeShortcode("Header");
const ErrorReference = makeShortcode("ErrorReference");
const Checkbox = makeShortcode("Checkbox");
const layoutProps = {
  metadata
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Header title='reCAPTCHA errors' subtitle='Guide to troubleshooting reCAPTCHA errors' mdxType="Header" />
    <h4 {...{
      "id": "recaptcha_required"
    }}><strong parentName="h4">{`RECAPTCHA_REQUIRED`}</strong></h4>
    <ErrorReference type='RECAPTCHA_ERROR' error='RECAPTCHA_REQUIRED' subtitle="The request was flagged by Plaid's fraud system, and requires additional verification to ensure the user is not a bot." client mdxType="ErrorReference">
      <h5 {...{
        "id": "link-user-experience"
      }}>{`Link user experience`}</h5>
      <p>{`Your user will be prompted to solve a `}<a parentName="p" {...{
          "href": "https://www.google.com/recaptcha/intro/v3.html"
        }}>{`Google reCAPTCHA`}</a>{` challenge in the Link `}<inlineCode parentName="p">{`Recaptcha`}</inlineCode>{` pane.
If they solve the challenge successfully, the user's request is resubmitted and they are directed to the next Item creation step.`}</p>
      <h5 {...{
        "id": "common-causes"
      }}>{`Common causes`}</h5>
      <ul>
        <li parentName="ul">{`Plaid's fraud system detects abusive traffic and considers a variety of parameters throughout Item creation requests.
When a request is considered risky or possibly fraudulent, Link presents a reCAPTCHA for the user to solve.`}</li>
      </ul>
      <h5 {...{
        "id": "troubleshooting-steps"
      }}>{`Troubleshooting steps`}</h5>
      <p>{`Link will automatically guide your user through reCAPTCHA verification. As a general rule, we recommend instrumenting basic fraud monitoring to detect and protect your website from spam and abuse.`}</p>
      <p>{`If your user cannot verify their session, please submit a `}<a parentName="p" {...{
          "href": "https://dashboard.plaid.com/support/new"
        }}>{`Support`}</a>{` ticket with the following identifiers: `}<inlineCode parentName="p">{`link_session_id`}</inlineCode>{` or `}<inlineCode parentName="p">{`request_id`}</inlineCode>{`.`}</p>
    </ErrorReference>
    <h4 {...{
      "id": "recaptcha_bad"
    }}><strong parentName="h4">{`RECAPTCHA_BAD`}</strong></h4>
    <ErrorReference type='RECAPTCHA_ERROR' error='RECAPTCHA_BAD' subtitle='The provided challenge response was denied.' client mdxType="ErrorReference">
      <h5 {...{
        "id": "link-user-experience-1"
      }}>{`Link user experience`}</h5>
      <p>{`If after several failed attempts your user is still unable to solve the reCAPTCHA challenge,
the `}<inlineCode parentName="p">{`RECAPTCHA_BAD`}</inlineCode>{` error is returned and they are directed to the Institution Select pane to connect a new account.`}</p>
      <h5 {...{
        "id": "common-causes-1"
      }}>{`Common causes`}</h5>
      <ul>
        <li parentName="ul">{`The user was unable to successfully solve the presented reCAPTCHA problem after several attempts.`}</li>
        <li parentName="ul">{`The current session is a bot or other malicious software.`}</li>
      </ul>
      <h5 {...{
        "id": "troubleshooting-steps-1"
      }}>{`Troubleshooting steps`}</h5>
      <Checkbox mdxType="Checkbox">
        <p>{`Verify your user's session -- reCAPTCHA is built to allow valid users to pass through with ease. If a user was unable to solve the challenge, they may be a bad actor.`}</p>
      </Checkbox>
      <p>{`If your user cannot verify their session, please submit a `}<a parentName="p" {...{
          "href": "https://dashboard.plaid.com/support/new"
        }}>{`Support`}</a>{` ticket with the following identifiers: `}<inlineCode parentName="p">{`link_session_id`}</inlineCode>{` or `}<inlineCode parentName="p">{`request_id`}</inlineCode>{`.`}</p>
    </ErrorReference>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;

            export const tableOfContents = [
      {
        id: "recaptcha_required",
        level: 4,
        title: "RECAPTCHA_REQUIRED",
      },
{
        id: "recaptcha_bad",
        level: 4,
        title: "RECAPTCHA_BAD",
      }
];
          
layoutProps.tableOfContents = tableOfContents;
MDXContent.layoutProps = layoutProps;

MDXContent.layout = function (props) { return <DocsBeta {...props} /> };
